import { Helper } from "./helper";

const extract_params = (params) => {

    let urlParams = '';
    for (var i = 0; i < params.length; i++)
        urlParams += `&${Object.entries(params[i])[0][0]}=${Object.entries(params[i])[0][1]}`;
    return urlParams;
};

export async function login(data) {
    return Helper.Post({ url: `/admin/auth/login`, data });
};

export async function logout(data) {
    return Helper.Post({ url: `/admin/profile/logout`, data });
};

export async function refresh(data) {
    return Helper.Post({ url: `/admin/profile/refresh`, data });
};

export async function getMe() {
    return Helper.Get(`/admin/profile/me`);
};

//home page

export async function getStatistics() {
    return Helper.Get(`/admin/statistics`);
};

export async function getRevenueByTime( params = []) {
    return Helper.Get(`/admin/statistics/RevenueByTime?${extract_params(params)}`);
};

export async function getActiveAdsByTime( params = []) {
    return Helper.Get(`/admin/statistics/AdByTime?${extract_params(params)}`);
};

export async function getVisitByHours( params = []) {
    return Helper.Get(`/admin/statistics/VisitByHours?${extract_params(params)}`);
};

export async function getUserByHours( params = []) {
    return Helper.Get(`/admin/statistics/UserByTime?${extract_params(params)}`);
};

// Categoires Cruds

export async function getCategories(currentPage = 1, params = []) {    
    return Helper.Get(`/admin/categories?page=${currentPage}&per_page=30${extract_params(params)}`);
};

export async function getCategoryById(id) {
    return Helper.Get(`/admin/categories/${id}`);
};

export async function addCategoires(data) {
    return Helper.Post({ url: `/admin/categories`, data });
};

export async function updateCategoires(id, data) {
    return Helper.Post({ url: `/admin/categories/${id}`, data });
};

export async function deleteCategoires(id) {
    return Helper.Delete({ url: `/admin/categories/${id}` });
};

// Inputs Cruds 

export async function getInputs(currentPage = 1, params = []) {
    return Helper.Get(`/admin/inputs?page=${currentPage}&per_page=200${extract_params(params)}`);
};

export async function getInputById(id) {
    return Helper.Get(`/admin/inputs/${id}`);
};

export async function addInputs(data) {
    return Helper.Post({ url: `/admin/inputs`, data });
};

export async function updateInputs(id, data) {
    return Helper.Put({ url: `/admin/inputs/${id}`, data });
};

export async function deleteInputs(id) {
    return Helper.Delete({ url: `/admin/inputs/${id}` });
};

// Packages Cruds 

export async function getPackages(currentPage = 1, params = []) {
    return Helper.Get(`/admin/packages?page=${currentPage}&per_page=12${extract_params(params)}`);
};

export async function getPackageById(id) {
    return Helper.Get(`/admin/packages/${id}`);
};

export async function addPackages(data) {
    return Helper.Post({ url: `/admin/packages`, data });
};

export async function updatePackages(id, data) {
    return Helper.Put({ url: `/admin/packages/${id}`, data });
};

export async function deletePackages(id) {
    return Helper.Delete({ url: `/admin/packages/${id}` });
};

// Users Cruds 

export async function getUsers(currentPage = 1, params = []) {
    return Helper.Get(`/admin/users?page=${currentPage}&per_page=30${extract_params(params)}`);
};

export async function getUsersExport(perPage = 1, params = []) {
    return Helper.Get(`/admin/users?page=1&per_page=${perPage}${extract_params(params)}`);
};

export async function getUserById(id) {
    return Helper.Get(`/admin/users/${id}`);
};

export async function updateUsersStatus(id, data) {
    return Helper.Put({ url: `/admin/users/change_status/${id}`, data });
};

export async function updateConfirmUsers(id, data) {
    return Helper.Put({ url: `/admin/users/confirm/${id}`, data });
};

export async function deleteUsers(id) {
    return Helper.Delete({ url: `/admin/users/${id}` });
};

// Orders Cruds 

export async function getOrders(currentPage = 1, params = []) {
    return Helper.Get(`/admin/orders?page=${currentPage}&per_page=30${extract_params(params)}`);
};

export async function getOrdersExport(perPage = 1, params = []) {
    return Helper.Get(`/admin/orders?page=1&per_page=${perPage}${extract_params(params)}`);
};

export async function getOrderByUserId(id, currentPage = 1, params = []) {
    return Helper.Get(`/admin/users/orders/${id}?page=${currentPage}&per_page=10${extract_params(params)}`);
};

export async function updateConfirmOrders(id, data) {
    return Helper.Put({ url: `/admin/orders/confirm/${id}`, data });
};

// Ads Cruds 

export async function getAds(currentPage = 1, params = []) {
    return Helper.Get(`/admin/ads?page=${currentPage}&per_page=30${extract_params(params)}`);
};

export async function getAdsExport(perPage = 1, params = []) {
    return Helper.Get(`/admin/ads?page=1&per_page=${perPage}${extract_params(params)}`);
};

export async function getAdById(id) {
    return Helper.Get(`/admin/ads/${id}`);
};

export async function getAdByUserId(id, currentPage = 1, params = []) {
    return Helper.Get(`/admin/users/ads/${id}?page=${currentPage}&per_page=10${extract_params(params)}`);
};

export async function deleteAds(id) {
    return Helper.Delete({ url: `/admin/ads/${id}` });
};

// Categories Blogs Cruds

export async function getCategoriesBlog(currentPage = 1, params = []) {
    return Helper.Get(`/admin/blogs/categories?page=${currentPage}&per_page=10${extract_params(params)}`);
};

export async function getCategoryBlogById(id) {
    return Helper.Get(`/admin/blogs/categories/${id}`);
};

export async function addCategoriesBlog(data) {
    return Helper.Post({ url: `/admin/blogs/categories`, data });
};

export async function updateCategoriesBlog(id, data) {
    return Helper.Put({ url: `/admin/blogs/categories/${id}`, data });
};

export async function deleteCategoiresBlogs(id) {
    return Helper.Delete({ url: `/admin/blogs/categories/${id}` });
};

// Blogs Cruds

export async function getBlogs(currentPage = 1, params = []) {
    return Helper.Get(`/admin/blogs?page=${currentPage}&per_page=10${extract_params(params)}`);
};

export async function getBlogById(id) {
    return Helper.Get(`/admin/blogs/${id}`);
};

export async function addBlogs(data) {
    return Helper.Post({ url: `/admin/blogs`, data });
};

export async function updateBlogs(id, data) {
    return Helper.Post({ url: `/admin/blogs/${id}`, data });
};

export async function deleteBlogs(id) {
    return Helper.Delete({ url: `/admin/blogs/${id}` });
};

// Notification Cruds

export async function getNotifications(currentPage = 1, params = []) {
    return Helper.Get(`/admin/notification?page=${currentPage}&per_page=21${extract_params(params)}`);
};

export async function getNotificationsUnread(currentPage = 1, params = []) {
    return Helper.Get(`/admin/notification?type=unread&page=${currentPage}&per_page=21${extract_params(params)}`);
};

export async function updateReadAllNotifications() {
    return Helper.Put({ url: `/admin/notification/all`});
};

export async function updateReadNotification(id, data) {
    return Helper.Put({ url: `/admin/notification/${id}`, data });
};

export async function addNotifications(data) {
    return Helper.Post({ url: `/admin/alert`, data });
};

export async function getOutComingNotifications(currentPage = 1, params = []) {
    return Helper.Get(`/admin/alert?page=${currentPage}&per_page=21${extract_params(params)}`);
};

// Payment Method Cruds

export async function getPaymentMethod() {
    return Helper.Get(`/admin/payments`);
};

export async function updatePaymentMethod(id, data) {
    return Helper.Put({ url: `/admin/payments/${id}`, data });
};


// Roles and Permissions Cruds

export async function getRoles(page = 1, params = []) {
    return Helper.Get(`/admin/roles?page=${page}&per_page=10${extract_params(params)}`);
};

export async function addRoles(data) {
    return Helper.Post({ url: `/admin/roles`, data });
};

export async function getRoleById(id) {
    return Helper.Get(`/admin/roles/${id}`);
};

export async function updateRoles(id, data) {
    return Helper.Put({ url: `/admin/roles/${id}`, data });
};

export async function updatePermissions(id, data) {
    return Helper.Put({ url: `/admin/roles/permissions/${id}`, data });
};

export async function delelteRoles(id) {
    return Helper.Delete({ url: `/admin/roles/${id}` });
};

// employees Cruds

export async function getEmployees(page = 1, params = []) {
    return Helper.Get(`/admin/employees?page=${page}&per_page=10${extract_params(params)}`);
};

export async function addEmployees(data) {
    return Helper.Post({ url: `/admin/employees`, data });
};

export async function getEmployeeById(id) {
    return Helper.Get(`/admin/employees/${id}`);
};

export async function updateEmployees(id, data) {
    return Helper.Put({ url: `/admin/employees/${id}`, data });
};

export async function delelteEmployees(id) {
    return Helper.Delete({ url: `/admin/employees/${id}` });
};

// reports Cruds

export async function getReports(page = 1, params = []) {
    return Helper.Get(`/admin/report?page=${page}&per_page=10${extract_params(params)}`);
};

export async function getReportsExport(perPage = 1, params = []) {
    return Helper.Get(`/admin/report?page=1&per_page=${perPage}${extract_params(params)}`);
};

export async function getReportsByUserId(id, currentPage = 1, params = []) {
    return Helper.Get(`/admin/report?user_id=${id}&page=${currentPage}&per_page=10${extract_params(params)}`);
};

export async function updateReportStatus(id) {
    return Helper.Put({ url: `/admin/report/${id}` });
};

// Page Cruds

export async function getPages(page = 1, params = []) {
    return Helper.Get(`/admin/page?page=${page}&per_page=10${extract_params(params)}`);
};

export async function addPages(data) {
    return Helper.Post({ url: `/admin/page`, data });
};

export async function getPageById(id) {
    return Helper.Get(`/admin/page/${id}`);
};

export async function updatePages(id, data) {
    return Helper.Put({ url: `/admin/page/${id}`, data });
};

export async function deleltePages(id) {
    return Helper.Delete({ url: `/admin/page/${id}` });
};

// PageSection Cruds

export async function getPagesSection(page = 1, params = []) {
    return Helper.Get(`/admin/page/section?page=${page}&per_page=10${extract_params(params)}`);
};

export async function addPagesSection(data) {
    return Helper.Post({ url: `/admin/page/section`, data });
};

export async function getPageSectionById(id) {
    return Helper.Get(`/admin/page/section/${id}`);
};

export async function updatePagesSection(id, data) {
    return Helper.Post({ url: `/admin/page/section/${id}`, data });
};

export async function deleltePagesSection(id) {
    return Helper.Delete({ url: `/admin/page/section/${id}` });
};

// Banners Cruds

export async function getBanners(page = 1, params = []) {
    return Helper.Get(`/admin/banners?page=${page}&per_page=10${extract_params(params)}`);
};

export async function addBanners(data) {
    return Helper.Post({ url: `/admin/banners`, data });
};

export async function getBannerById(id) {
    return Helper.Get(`/admin/banners/${id}`);
};

export async function updateBanners(id, data) {
    return Helper.Post({ url: `/admin/banners/${id}`, data });
};

export async function delelteBanners(id) {
    return Helper.Delete({ url: `/admin/banners/${id}` });
};

// marketing promotion Cruds

export async function getMarketingPromotions(page = 1, params = []) {
    return Helper.Get(`/admin/marketing/promotions?page=${page}&per_page=10${extract_params(params)}`);
};

export async function addMarketingPromotions(data) {
    return Helper.Post({ url: `/admin/marketing/promotions`, data });
};

export async function getMarketingPromotionById(id) {
    return Helper.Get(`/admin/marketing/promotions/${id}`);
};

export async function updateMarketingPromotions(id, data) {
    return Helper.Post({ url: `/admin/marketing/promotions/${id}`, data });
};

export async function delelteMarketingPromotions(id) {
    return Helper.Delete({ url: `/admin/marketing/promotions/${id}` });
};